import { Button, Modal } from "antd";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../hooks/redux-hooks";
import { setShowRestrictionModal } from "../../slices/appStateSlice";

const FeatureRestricted = () => {
  const dispatch = useDispatch();
  const { showRestrictionModal } = useAppSelector((state) => state.appState);

  const hideModal = () => {
    dispatch(setShowRestrictionModal(false));
  };
  return (
    <Modal
      open={showRestrictionModal}
      onCancel={() => hideModal()}
      footer={null}
      centered
      title="This Feature Works Best on Desktop"
    >
      <div>
        To access this feature please visit{" "}
        <span style={{ userSelect: "none", pointerEvents: "none" }}>app.getnudgeai.com</span> from your desktop device.
        <br />
      </div>
    </Modal>
  );
};

export default FeatureRestricted;
